const BackgroundTreeGetters = {
  getBackground: (state) => (routePath) =>
    state.backgroundTree.getBackgroundResourceByPath(routePath),
}
export default BackgroundTreeGetters
